import React from "react";
import "../styles/TechUsed.css";

export default function TechUsed() {
  return (
    <div className="techUsed">
      <div className="techUsedTitle">Technologies & Tools</div>
      <div className="techUsedButtons">
        <button className="techUsedButton">Games & Entertainment</button>
        <button className="techUsedButton">Music & Sound</button>
        <button className="techUsedButton">Technology</button>
        <button className="techUsedButton">Graphic design</button>
        <button className="techUsedButton">Parallax</button>
        <button className="techUsedButton">Transition</button>
        <button className="techUsedButton">Storytelling</button>
        <button className="techUsedButton">UI design</button>

        <button className="techUsedButton">next.js</button>
      </div>
    </div>
  );
}
